import Vue from 'vue';
import Router, { Route } from 'vue-router';
import routes from '@/router/Routes';
import store from '@/store';
import {
  APP_UPDATE_PAGE_TITLE,
  USER_LOGOUT,
  APP_UPDATE_PICKER_STATUS
} from '@/store/mutypes';
import { Notification } from 'element-ui';

Vue.use(Router);

const router: Router = new Router({
  base: '/',
  mode: 'history',
  routes
});

router.beforeEach(async (to, from, next) => {
  if (to.meta.permission && !store.getters.hasPermission(to.meta.permission)) {
    Notification.error('No permission to view this page.');
    next({ name: 'dashboard' });
  }

  if (!to.meta.public) {
    store.dispatch('validateJwtToken');
  }

  store.commit(APP_UPDATE_PICKER_STATUS, to.meta.showDateRangePicker === true);

  if (to.meta.pageTitle) {
    store.commit(APP_UPDATE_PAGE_TITLE, to.meta.pageTitle);
  }
  if (to.params.pageTitle) {
    store.commit(APP_UPDATE_PAGE_TITLE, to.params.pageTitle);
  }

  next();
});

export default router;
